/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Input_Company_LabelInputs */

const en_jobs_input_company_label = /** @type {(inputs: Jobs_Input_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const de_jobs_input_company_label = /** @type {(inputs: Jobs_Input_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

const fr_jobs_input_company_label = /** @type {(inputs: Jobs_Input_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entreprise`)
};

const es_jobs_input_company_label = /** @type {(inputs: Jobs_Input_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresa`)
};

const it_jobs_input_company_label = /** @type {(inputs: Jobs_Input_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azienda`)
};

const nl_jobs_input_company_label = /** @type {(inputs: Jobs_Input_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrijf`)
};

const pl_jobs_input_company_label = /** @type {(inputs: Jobs_Input_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firma`)
};

const fi_jobs_input_company_label = /** @type {(inputs: Jobs_Input_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yritys`)
};

const da_jobs_input_company_label = /** @type {(inputs: Jobs_Input_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firma`)
};

const sv_jobs_input_company_label = /** @type {(inputs: Jobs_Input_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Företag`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Jobs_Input_Company_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_input_company_label = /** @type {((inputs?: Jobs_Input_Company_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Input_Company_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_input_company_label(inputs)
	if (locale === "fr") return fr_jobs_input_company_label(inputs)
	if (locale === "es") return es_jobs_input_company_label(inputs)
	if (locale === "it") return it_jobs_input_company_label(inputs)
	if (locale === "nl") return nl_jobs_input_company_label(inputs)
	if (locale === "pl") return pl_jobs_input_company_label(inputs)
	if (locale === "fi") return fi_jobs_input_company_label(inputs)
	if (locale === "da") return da_jobs_input_company_label(inputs)
	if (locale === "sv") return sv_jobs_input_company_label(inputs)
	return en_jobs_input_company_label(inputs)
});